export default "__VITE_ASSET__68cc262d__"